import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../../../shared/api'

/** Link a self-hosted virtual-tour URL to a school (PUT /api/schulen/{id}/tour). */
export function useLinkTour() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, embedUrl, tourName }: { id: string; embedUrl: string; tourName?: string | null }) =>
      api.put<{ linked: boolean; tourEmbedUrl: string; tourName: string | null }>(
        `/api/schulen/${encodeURIComponent(id)}/tour`,
        { embedUrl, tourName: tourName ?? null },
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schulen'] }),
  })
}

/** Remove the active tour link from a school (DELETE /api/schulen/{id}/tour). */
export function useUnlinkTour() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      api.delete<{ linked: boolean }>(`/api/schulen/${encodeURIComponent(id)}/tour`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['schulen'] }),
  })
}
